import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entregas-completas',
  templateUrl: './entregas-completas.component.html',
  styleUrls: ['./entregas-completas.component.css']
})
export class EntregasCompletasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
